import { i18nKeyType } from '../i18n';

export enum Theme {
  SYSTEM = 'system',
  DARK = 'dark',
  LIGHT = 'light',
}

export interface Branding {
  cssClass: string | undefined;
  forceColorScheme: Theme | undefined;
}

export interface Partner {
  name: string;
  label: i18nKeyType;
  branding?: Branding;
}

const DefaultPartner: Partner = {
  name: 'beacon',
  label: 'common:partner_beacon',
};

const Partners: Partner[] = [
  DefaultPartner,
  {
    name: 'esab',
    label: 'common:partner_esab',
    branding: {
      cssClass: 'esab',
      forceColorScheme: Theme.DARK,
    },
  },
];

export { DefaultPartner, Partners };
